module.exports = __webpack_public_path__ + "img/icon_note.5b8c441c.png";